import HttpService from '@/api/HttpService';
import { downloadCSVBlob } from '../../util';

export default {
  namespaced: true,
  actions: {
    getNonDisplayedPreferences({ commit }) { // eslint-disable-line no-unused-vars
      return HttpService.get('impact-preferences/non-displayed')
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    getImpactPreferences({ commit }) { // eslint-disable-line no-unused-vars
      return HttpService.getV2('impact-preferences')
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    exportImpactPreferencesReport({ commit }) { // eslint-disable-line no-unused-vars
      return HttpService.getV2('reports/impact-preferences').then(blob =>
        downloadCSVBlob('impact_preferences.csv', blob),
      );
    },
    getSeparatedDisplayedAndNonDisplayedPreferencesAdmin({ commit }, {
      impactPreferences,
      accountImpactPreferences,
    }) {
      const result = impactPreferences.reduce((acc, preference) => {
        const preferenceObj = Object.assign({}, preference, { isSelected: false });
        const selectedPreference = accountImpactPreferences
               .find(accountPreference => accountPreference.id === preferenceObj.id);
        if (selectedPreference) {
          selectedPreference.isSelected = !!selectedPreference;
        }

        if (preferenceObj.preferenceDisplay) {
          acc.displayedPreferences.push(selectedPreference || preferenceObj);
          acc.displayedPreferences.sort((a, b) => a.id - b.id);
        } else {
          acc.nonDisplayedPreferences.push(selectedPreference || preferenceObj);
        }
        return acc;
      }, { displayedPreferences: [], nonDisplayedPreferences: [] });
      result.nonDisplayedPreferences.sort((a, b) => a.id - b.id);
      result.displayedPreferences.sort((a, b) => a.id - b.id);
      return result;
    },
    getSeparatedDisplayedAndNonDisplayedPreferencesInvestor({ commit }, {
      impactPreferences,
      accountImpactPreferences,
    }) {
      const result = impactPreferences.reduce((acc, preference) => {
        const preferenceObj = Object.assign({}, preference, { isSelected: false });
        const selectedPreference = accountImpactPreferences
               .find(accountPreference => accountPreference.id === preferenceObj.id);
        if (selectedPreference) {
          selectedPreference.isSelected = !!selectedPreference;
        }

        if (preferenceObj.preferenceDisplay) {
          acc.displayedPreferences.push(selectedPreference || preferenceObj);
          acc.displayedPreferences.sort((a, b) => a.id - b.id);
        } else if (selectedPreference) {
          acc.nonDisplayedPreferences.push(selectedPreference || preferenceObj);
        }
        return acc;
      }, { displayedPreferences: [], nonDisplayedPreferences: [] });
      result.nonDisplayedPreferences.sort((a, b) => a.id - b.id);
      result.displayedPreferences.sort((a, b) => a.id - b.id);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/impactPreferences.js